/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getFittedBounds helper
 *                Makes an educated guess about bounds given the center, zoom,
 *                dimensions, and tileSize.
 */

import type { MaybeEmpty } from '@zcode/utility-types'
import { TILE_SIZE } from '../../constants'
import type { Dimensions, MaybeNullCoords } from '../../types'
import { createMercator } from './createMercator'
interface GetFittedBounds {
  center: MaybeEmpty<MaybeNullCoords>
  zoom: number
  dimensions: Dimensions
  tileSize?: number
}

export const getFittedBounds = ({
  center,
  zoom,
  dimensions,
  tileSize = TILE_SIZE,
}: GetFittedBounds) => {
  const { lat, lng } = center
  const { width, height } = dimensions

  const merc = createMercator(tileSize)
  const [x, y] = merc.px([lng ?? 0, lat ?? 0], zoom)
  const [minLng, maxLat] = merc.ll([x - (width ?? 0) / 2, y - (height ?? 0) / 2], zoom)
  const [maxLng, minLat] = merc.ll([x + (width ?? 0) / 2, y + (height ?? 0) / 2], zoom)
  return { minLng, minLat, maxLng, maxLat }
}
